'use client';

import { useState } from 'react';
import { AlertManager } from '@dealroadshow/uikit-alert';
import { getContainer } from '@framework/di/getContainer';
import { useMessageManager } from '@framework/message';
import { messageCodes } from '@framework/message/messages';
import Logger from '@framework/sentry/Logger';
import TenantConfig from '@framework/tenant/TenantConfig';
import FrontChatService from './FrontChatService';

interface IProps {
  children: React.ReactNode | ((isLoading: boolean) => React.ReactNode),
}

const ContactSupport = (props: IProps) => {
  const container = getContainer();
  const frontChatService = container.get(FrontChatService);
  const { getMessageByName } = useMessageManager();
  const [isLoading, setIsLoading] = useState(false);

  const onClick = async () => {
    if (isLoading) {
      return;
    }

    const chatId = TenantConfig.fromHostname()?.supportChatId;
    if (!chatId) {
      AlertManager.warning(getMessageByName(messageCodes.SUPPORT_CHAT_UNAVAILABLE));
      Logger.error({
        message: 'Support chat ID for current tenant not found.',
        context: { status: frontChatService.getStatus() },
      });
      return;
    }

    if (frontChatService.getStatus() !== 'ready') {
      setIsLoading(true);
    }

    try {
      await frontChatService.show(chatId);
    } catch (error) {
      AlertManager.warning(getMessageByName(messageCodes.SUPPORT_CHAT_UNAVAILABLE));
      Logger.error({
        message: 'Failed to open support chat',
        error,
        context: { status: frontChatService.getStatus() },
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      onClick={ onClick }
      data-test="contactSupportButton"
    >
      { typeof props.children === 'function' ? props.children(isLoading) : props.children }
    </div>
  );
};

export default ContactSupport;
